const e = { last_updated: "Senast uppdaterat", Series_type: "Serie", "How to guide_type": "Guide", FAQ_type: "Standard" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies37.js.map
